module.exports = __webpack_public_path__ + "static/media/PCHENGZHI_MENU-normal.0a67af8b.png";